import { classToPlain, plainToClass } from "class-transformer";
import { MedicineDeliveryRequest } from "src/domains/medicine-delivery/models/request";

class MedicineDeliveryRequestMapping {
    static fromJson(json: Record<string, unknown>): MedicineDeliveryRequest {
        return plainToClass(MedicineDeliveryRequest, json);
    }

    static toJson(request: MedicineDeliveryRequest): Record<string, unknown> {
        return classToPlain(request);
    }

    static fromJsonArray(
        jsonArray: Record<string, unknown>[]
    ): MedicineDeliveryRequest[] {
        return jsonArray.map((json) =>
            plainToClass(MedicineDeliveryRequest, json)
        );
    }

    static toJsonArray(
        requests: MedicineDeliveryRequest[]
    ): Record<string, unknown>[] {
        return requests.map((request) => classToPlain(request));
    }
}

export { MedicineDeliveryRequestMapping };
